// LeaveRequestModal.jsx — Demande de départ / suppression envoyée au président (web).
import { useState } from 'react';
import { api } from '@/lib/api';
import { DoorOpen, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';

export default function LeaveRequestModal({ onClose, onSent }) {
  const [motif, setMotif] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post('/account/deletion-request', { motif });
      toast.success('Votre demande a été envoyée au président');
      onSent && onSent();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erreur lors de l\'envoi');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[90] bg-[#0F172A]/60 backdrop-blur-md grid place-items-center p-4" onClick={onClose} data-testid="leave-request-modal">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-7" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div className="w-12 h-12 rounded-2xl bg-[#FFF7ED] grid place-items-center">
            <DoorOpen className="w-6 h-6 text-[#B45309]" />
          </div>
          <button onClick={onClose} className="text-[#94A3B8] hover:text-[#0F172A]" data-testid="leave-request-cancel"><X className="w-5 h-5" /></button>
        </div>
        <h2 className="font-display text-2xl font-bold text-[#0F172A] mb-2">Quitter l'association</h2>
        <p className="text-sm text-[#475569] leading-relaxed mb-5">
          Votre demande sera envoyée au président. Après validation par le bureau, votre compte sera supprimé.
          Vous ne pouvez pas supprimer votre compte vous-même.
        </p>
        <label className="block text-[10px] font-bold uppercase tracking-[0.14em] text-[#475569] mb-2">Motif (facultatif)</label>
        <textarea
          value={motif}
          onChange={(e) => setMotif(e.target.value)}
          className="ap-input min-h-[90px] resize-y"
          placeholder="Ex. : je déménage, je ne pratique plus…"
          data-testid="leave-request-motif"
        />
        <div className="flex gap-2 justify-end mt-6">
          <button onClick={onClose} className="px-4 py-2.5 rounded-xl text-sm font-semibold text-[#475569] hover:bg-[#F1F5F9]">Annuler</button>
          <button onClick={submit} disabled={loading} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#B45309] hover:bg-[#92400E] text-white text-sm font-bold disabled:opacity-50" data-testid="leave-request-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Envoyer ma demande
          </button>
        </div>
      </div>
    </div>
  );
}
